/**
 * Formats a number with comma separators for better readability
 * @param num - The number to format
 * @returns Formatted number string (e.g., "1,000" instead of "1000")
 */
export const formatNumber = (num: number): string => {
  return num.toLocaleString('en-US');
};

/**
 * Formats a number as a compact string for very large numbers
 * @param num - The number to format
 * @returns Compact formatted number (e.g., "1.2K", "1.5M")
 */
export const formatCompactNumber = (num: number): string => {
  return num.toLocaleString('en-US', { 
    notation: 'compact', 
    maximumFractionDigits: 1 
  });
};
